// noinspection DuplicatedCode

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import { isRequired, useForm } from "../../../../components/isRequired";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { alertService } from "../../../../services/AlertService";

import Loading from "../../../../components/loading/Loading";

import {
  deleteLembur,
  getSpecLembur,
  lemburTransaksiSelector,
  updateLemburTransaksi,
} from "./lemburTransaksiSlice";
import { approve } from "../../../setup/approval/approvalSlice";
import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../../../master/tipe-karyawan/tipeKaryawanSlice";
import Card from "@material-tailwind/react/Card";
import Skeltons from "../../../../components/loading/Skeltons";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getMinKaryawan, karyawanSelector } from "../../karyawan/karyawanSlice";
import { jabatanSelector } from "../../../master/jabatan/jabatanSlice";

import { bagianSelector } from "../../../master/bagian/bagianSlice";
import { Colors } from "../../../../assets/Colors";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";
import { HrdInputGenerator } from "../../../../components/form/HrdInputGenerator";
import { createNotification } from "../../../../components/notification/notification";

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  fetchPost,
  fetchPostSilance,
  fetchPostMultipartSeaweed,
} from "../../../../fetchers";

// Parse tanggal lembur (toleran: ISO / "YYYY-MM-DD HH:MM:SS" dan "DD-MM-YYYY HH:MM").
const parseLemburTgl = (s) => {
  if (!s) return null;
  const str = String(s).trim();
  let m = str.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
  m = str.match(/^(\d{2})-(\d{2})-(\d{4})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5], +(m[6] || 0));
  const d = new Date(str);
  return isNaN(d.getTime()) ? null : d;
};

// Jam dinding LOKAL perangkat → "YYYY-MM-DDTHH:mm:ss" TANPA zona. Backend menyimpan digit
// ini apa adanya (kolom timestamp tanpa zona), jadi jam yang dipilih user = jam tersimpan,
// di zona mana pun perangkat/server berada (WITA/WIB). JANGAN pakai toISOString(): itu UTC,
// lalu backend mengonversinya ke Asia/Jakarta → user WITA tersimpan mundur 1 jam.
const toLocalTgl = (d) => {
  if (!(d instanceof Date) || isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}:00`;
};


// Opsi dropdown "Jenis Hari" — "" = ikut auto-detect backend (kalender libur/hari Minggu).
const JENIS_HARI_OPTIONS = [
  { value: "", label: "Otomatis (deteksi sistem)" },
  { value: "1", label: "Hari Kerja Biasa" },
  { value: "2", label: "Hari Istirahat Mingguan" },
  { value: "3", label: "Hari Libur Resmi" },
];

// Durasi lembur dari selisih mulai–akhir. Format "H jam M menit" (menit disembunyikan bila 0).
const formatDurasiLembur = (mulai, akhir) => {
  const a = parseLemburTgl(mulai);
  const b = parseLemburTgl(akhir);
  if (!a || !b) return "-";
  const menitTotal = Math.max(0, Math.round((b - a) / 60000));
  const jam = Math.floor(menitTotal / 60);
  const menit = menitTotal % 60;
  return menit > 0 ? `${jam} jam ${menit} menit` : `${jam} jam`;
};

const LemburPage = ({}) => {
  let initialState = {
    Nik: "",
    JenisLembur: "",
    KeperluanLembur: "",
    PemberiInstruksiLembur: "",
    NoSPL: "",
    Harikeenam: false,
  };

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    // ({ JenisLembur }) =>
    //   isRequired(JenisLembur) || { JenisLembur: "Jenis lembur wajib diisi" },
    // No SPL di-generate otomatis oleh server saat simpan → tidak divalidasi di form.

    // ({ KeperluanLembur }) =>
    //   isRequired(KeperluanLembur) || {
    //     KeperluanLembur: "Keperluan lembur wajib diisi",
    //   },
    // ({ PemberiInstruksiLembur }) =>
    //   isRequired(PemberiInstruksiLembur) || {
    //     PemberiInstruksiLembur: "Pemberi instruksi lembur wajib diisi",
    //   },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);
  const mutation = useMutation((param) => fetchPost("getLembur", param));

  const mutationInput = useMutation((param) =>
    fetchPostSilance("insertLembur", param)
  );

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );

  // Preview kalkulasi upah lembur (PP 35/2021) — TIDAK menyimpan apa pun, hanya
  // dipakai menampilkan breakdown transparan sebelum submit. Backend adalah
  // sumber tunggal (endpoint sama juga dipakai ulang saat insertLembur/updateLembur
  // menyimpan), jadi angka yang tampil di sini dijamin identik dengan yang tersimpan.
  const previewMutation = useMutation((param) =>
    fetchPostSilance("hitungLembur", param)
  );
  const [jenisHariOverride, setJenisHariOverride] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [TanggalMulai, setTanggalMulai] = useState("");
  const [TanggalMulaiSelect, setTanggalMulaiSelect] = useState("");
  const [TanggalAkhir, setTanggalAkhir] = useState("");
  const [TanggalAkhirSelect, setTanggalAkhirSelect] = useState("");
  const [isValidTanggalMulai, setIsValidTanggalMulai] = useState(true);
  const [isValidTanggalAkhir, setIsValidTanggalAkhir] = useState(true);
  const [dateChanged, setDateChanged] = useState(false);
  const [JamMulai, setJamMulai] = useState("");
  const [JamAkhir, setJamAkhir] = useState("");
  const [isValidJamMulai, setIsValidJamMulai] = useState(true);
  const [isValidJamAkhir, setIsValidJamAkhir] = useState(true);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(5);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [isCheckstatusEdit, setisCheckstatusEdit] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [detailID, setDetailID] = useState("");
  const [detailRow, setDetailRow] = useState({});

  const [TipeKaryawan, setTipeKaryawan] = useState("");
  const [Bulan, setBulan] = useState(new Date());

  const lembur = useSelector(lemburTransaksiSelector);
  const karyawan = useSelector(karyawanSelector);
  const jabatan = useSelector(jabatanSelector);
  const bagian = useSelector(bagianSelector);
  const tipeKaryawan = useSelector(tipeKaryawanSelector);

  const [searchQuery, setSearchQuery] = useState("");
  const [pageC, setPageC] = useState(1);
  const PAGE_SIZE = 10;

  useEffect(() => {
    mutation.mutate({
      start: start,
      count: count,
      search: "",
      tipekaryawan: "",
      Bulan: (new Date().getMonth() + 1).toString(),
      Tahun: new Date().getFullYear().toString(),
    });
    dispatch(getMinTipeKaryawan({ search: "" }));
  }, []);
  const reapprove = () => {
    mutation.mutate({
      start: start,
      count: count,
      tipekaryawan: TipeKaryawan,
      search: "",
    });
  };
  // useEffect(() => {
  //   console.log(values);
  //   console.log(isCheckstatusEdit);
  // }, [values]);

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      const initValues = {
        Nik: currentData.Nik,
        JenisLembur: currentData.JenisLembur,
        KeperluanLembur: currentData.KeperluanLembur,
        PemberiInstruksiLembur: currentData.PemberiInstruksiLembur,
      };
      editHandler(initValues);
      // parseLemburTgl, BUKAN new Date(): API mengirim jam dinding DB berakhiran "Z"
      // (lib/pq), new Date() akan menggesernya +7/+8 jam → tersimpan bergeser saat Edit.
      const mulaiEdit = parseLemburTgl(currentData.TanggalMulai);
      const akhirEdit = parseLemburTgl(currentData.TanggalAkhir);
      setTanggalMulai(mulaiEdit || "");
      setTanggalMulaiSelect(mulaiEdit || "");
      setTanggalAkhir(akhirEdit || "");
      setTanggalAkhirSelect(akhirEdit || "");
    }

    if (search !== "" && lembur.isGetSuccess && !lembur.isGetFetching) {
      let calc = lembur?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = lembur.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    } else if (search === "" && lembur.isGetSuccess && !lembur.isGetFetching) {
      let calc = lembur?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = lembur.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    }

    if (lembur.isGetSuccess && maxPage === 0 && firstLoading === false) {
      let calc = lembur?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = lembur.data ? Math.ceil(calc / count) : 1;
      setMaxPage(tempMaxPage);
      setFirstLoading(true);
      mutation.mutate({
        start: start,
        count: count,
        search: search,
      });
    }

    if (insertFetch) {
      setInsertFetch(false);
      if (lembur.isGetSuccess) {
        alertService.success(lembur.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        mutation.mutate({
          start: start,
          count: count,
          search: search,
        });
      }
    }

    if (updateFetch) {
      setUpdateFetch(false);
      if (lembur.isUpdateSuccess) {
        alertService.success(lembur.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        mutation.mutate({
          start: start,
          count: count,
          search: search,
        });
      }
    }
  });

  // Periode aktif (dari state Bulan) — WAJIB ikut di tiap refetch, kalau tidak
  // backend akan default ke bulan berjalan dan data periode terpilih hilang.
  const periodeParams = () => ({
    tipekaryawan: TipeKaryawan,
    Bulan: isNaN(new Date(Bulan).getMonth() + 1)
      ? (new Date().getMonth() + 1).toString()
      : (new Date(Bulan).getMonth() + 1).toString(),
    Tahun: isNaN(new Date(Bulan).getFullYear())
      ? new Date().getFullYear().toString()
      : new Date(Bulan).getFullYear().toString(),
  });

  function handleSearch(searchValue) {
    mutation.mutate({ start: 0, count: 5, search: searchValue, ...periodeParams() });
    setStart(0);
    setCount(5);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;
    mutation.mutate({ start: newStart, count: count, search: search, ...periodeParams() });
    setPage(newPage);
    setStart(newStart);
  }

  function handleUpdateCount(newCount) {
    let calc = lembur.count - 1;
    if (calc === 0) {
      calc = 1;
    }
    mutation.mutate({
      start: newCount === "-1" ? 0 : start,
      count: newCount === "-1" ? lembur.count : newCount,
      search: search,
      ...periodeParams(),
    });
    setPage(1);
    setCount(newCount === "-1" ? lembur.count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function searchTipeKaryawanHandler(searchValue) {
    let params = {
      start: start,
      count: count,
      tipekaryawan: searchValue,
      search: "",
      Bulan: isNaN((new Date(Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(Bulan).getFullYear().toString(),
    };
    mutation.mutate(params);

    setTipeKaryawan(searchValue);
  }
  function bulanHandler(searchValue) {
    let params = {
      start: start,
      count: count,
      tipekaryawan: TipeKaryawan,
      search: "",
      Bulan: isNaN((new Date(searchValue).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(searchValue).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(searchValue).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(searchValue).getFullYear().toString(),
    };
    mutation.mutate(params);

    setBulan(searchValue);
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);

    dispatch(getMinKaryawan({ search: "" }));
  }

  // ── Data list (client-side search + sort + pagination) ──────
  const allRows = useMemo(() => {
    const d = mutation.data?.data;
    return Array.isArray(d) ? d : [];
  }, [mutation.data]);

  const refetchList = () =>
    mutation.mutate({ start: 0, count: count, search: "", ...periodeParams() });

  const filtered = useMemo(() => {
    let rows = [...allRows];
    const kw = searchQuery.trim().toLowerCase();
    if (kw) {
      rows = rows.filter((r) =>
        [r.TLemburID, r.NoSPL, r.NamaKaryawan, r.KeperluanLembur, r.TanggalMonitoring, r.StatusKet]
          .some((v) => v && v.toString().toLowerCase().includes(kw))
      );
    }
    return rows;
  }, [allRows, searchQuery]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(pageC, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPageC(1);
  }, [searchQuery, mutation.data]);

  const handleSearchChange = useCallback((e) => {
    setSearchQuery(typeof e === "string" ? e : e?.target?.value || "");
  }, []);

  // Ganti periode (bulan) → refetch server-side (backend memfilter per bulan).
  const onChangeBulan = (date) => {
    setBulan(date);
    mutation.mutate({
      start: 0,
      count: count,
      search: "",
      tipekaryawan: TipeKaryawan,
      Bulan: (new Date(date).getMonth() + 1).toString(),
      Tahun: new Date(date).getFullYear().toString(),
    });
  };

  // Debounce preview kalkulasi lembur — jalan setiap Nik/tanggal/jam/override
  // berubah selama modal Tambah/Edit terbuka.
  useEffect(() => {
    if (!showModalAdd) return;
    if (!values.Nik || !TanggalMulaiSelect || !TanggalAkhirSelect) return;
    const t = setTimeout(() => {
      const mulaiISO = toLocalTgl(TanggalMulaiSelect);
      const akhirISO = toLocalTgl(TanggalAkhirSelect);
      if (!mulaiISO || !akhirISO) return;
      let fd = new FormData();
      fd.append("Nik", values.Nik);
      fd.append("TanggalMulai", mulaiISO);
      fd.append("TanggalAkhir", akhirISO);
      fd.append("JenisHariOverride", jenisHariOverride);
      previewMutation.mutate(fd);
    }, 400);
    return () => clearTimeout(t);
  }, [showModalAdd, values.Nik, TanggalMulaiSelect, TanggalAkhirSelect, jenisHariOverride]);

  const preview = previewMutation.data?.data;

  // ── Aksi baris ──────────────────────────────────────────────
  const doEdit = (row) => {
    handleCurrentData(row);
    // Prefill override jenis hari kalau dokumen ini sebelumnya di-override manual.
    setJenisHariOverride(row.JenisHariOverride && row.JenisHari ? String(row.JenisHari) : "");
    handleModal({ showModalAdd: false, showModalEdit: true });
  };
  const doSend = async (row) => {
    try {
      const res = await dispatch(approve({ primary: row.TLemburID })).unwrap();
      if (res && res.data === "Berhasil") {
        toast.success("Lembur dikirim untuk approval", { position: "bottom-right", autoClose: 3000 });
      } else {
        toast.error((res && res.message) || "Gagal mengirim lembur", { position: "bottom-right", autoClose: 4000 });
      }
    } catch (e) {
      // Mis. Bagian karyawan belum punya alur approval Lembur di Setup > Approval.
      toast.error((e && e.message) || "Gagal mengirim lembur untuk approval", { position: "bottom-right", autoClose: 5000 });
    }
    refetchList();
  };
  const doDetail = (row) => {
    // Ambil detail approval (aktor + status + alasan tolak/terima) via getSpecLembur.
    setDetailID(row.TLemburID);
    setDetailRow(row);
    dispatch(getSpecLembur({ TransaksiApprovalID: row.TLemburID }));
    setShowModalDetail(true);
  };
  const doDelete = async (row) => {
    if (!window.confirm(`Hapus lembur ${row.TLemburID} (${row.NamaKaryawan})?`)) return;
    await dispatch(deleteLembur({ ID: row.TLemburID }));
    toast.success("Lembur dihapus", { position: "bottom-right", autoClose: 3000 });
    refetchList();
  };

  // ── Export (mengikuti hasil filter/search) ──────────────────
  const exportHeader = [
    "ID", "No SPL", "Nama Karyawan", "Keperluan Lembur", "Tanggal", "Durasi Lembur", "Jenis Hari", "Akumulasi Durasi (jam)", "Approval",
  ];
  const exportBody = () =>
    filtered.map((r) => [
      r.TLemburID || "",
      r.NoSPL || "",
      r.NamaKaryawan || "",
      r.KeperluanLembur || "",
      r.TanggalMonitoring || "",
      formatDurasiLembur(r.TanggalMulai, r.TanggalAkhir),
      r.JenisHariLabel || "-",
      r.FaktorLembur != null ? r.FaktorLembur : "-",
      // Kolom Approval: status ringkas + daftar aktor (status & nama).
      [
        r.StatusKet || "",
        ...(Array.isArray(r.ApprovalList)
          ? r.ApprovalList.map((a) => `${a.Status} ${a.Nama}`)
          : []),
      ]
        .filter(Boolean)
        .join(" | "),
    ]);
  const handleExportExcel = () =>
    downloadExcel({ fileName: "Lembur", sheet: "data", tablePayload: { header: exportHeader, body: exportBody() } });
  const handleExportPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(12);
    doc.text("Data Lembur", 14, 14);
    autoTable(doc, {
      head: [exportHeader],
      body: exportBody(),
      startY: 20,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
    });
    doc.save("Lembur.pdf");
  };

  const statusClass = (s) =>
    s === "Selesai"
      ? "bg-green-100 text-green-800"
      : s === "Belum Dikirim"
      ? "bg-gray-100 text-gray-700"
      : "bg-yellow-100 text-yellow-800";

  const colHeader = [
    "ID", "No SPL", "Nama Karyawan", "Keperluan Lembur", "Tanggal", "Durasi Lembur", "Akumulasi Durasi", "Approval", "Actions",
  ];

  let lamaLembur = 0;
  let statusLamaLembur = true;
  // if (TanggalMulai !== "" && TanggalAkhir !== "") {
  //   Math.round(
  //     (TanggalAkhir.getTime() - TanggalMulai.getTime()) / (1000 * 60 * 60 * 24)
  //   );
  // }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {/* ── Filter row ── */}
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-4 py-3 gap-4">
                  <div className="w-full sm:w-1/4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Periode
                    </label>
                    <DatePicker
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      selected={Bulan}
                      onChange={onChangeBulan}
                      className="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight outline-none bg-white"
                    />
                  </div>
                  <div className="w-full sm:w-1/4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Tipe Karyawan
                    </label>
                    <select
                      value={TipeKaryawan}
                      onChange={(e) => searchTipeKaryawanHandler(e.target.value)}
                      className="block appearance-none w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight outline-none bg-white h-[42px]"
                    >
                      <option value="">Semua Tipe</option>
                      {(tipeKaryawan?.minData || []).map((item) => (
                        <option key={item.TipeKaryawanID} value={item.NamaTipeKaryawan}>
                          {item.NamaTipeKaryawan}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {mutation.isLoading || lembur.isGetFetching ? (
                  <div className="w-full pt-0">
                    <Skeltons />
                  </div>
                ) : (
                  <>
                    {/* ── Toolbar: Tambah / Export / Search ── */}
                    <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2 gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={() => {
                            clearHandler();
                            setTanggalMulai("");
                            setTanggalMulaiSelect("");
                            setTanggalAkhir("");
                            setTanggalAkhirSelect("");
                            setButtonTouched(false);
                            setJenisHariOverride("");
                            handleCurrentData({});
                            handleModal({ showModalAdd: true, showModalEdit: false });
                          }}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                        >
                          Tambah +
                        </button>
                        <button
                          onClick={handleExportExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow"
                        >
                          Download Excel
                        </button>
                        <button
                          onClick={handleExportPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow"
                        >
                          Download PDF
                        </button>
                      </div>
                      <div className="flex flex-row w-96">
                        <input
                          type="text"
                          placeholder="Cari ID / Nama / Keperluan"
                          value={searchQuery}
                          onChange={handleSearchChange}
                          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                        />
                      </div>
                    </div>

                    {/* ── Tabel ── */}
                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {colHeader.map((h, i) => (
                              <th key={i} scope="col" className="py-3 px-6">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr>
                              <td colSpan={colHeader.length} className="text-center py-8 text-gray-400">
                                {searchQuery
                                  ? `Tidak ada data untuk "${searchQuery}"`
                                  : "Tidak ada data lembur pada periode ini"}
                              </td>
                            </tr>
                          ) : (
                            pageRows.map((row, id) => {
                              const isDraft = String(row.Status) === "-1";
                              return (
                                <tr
                                  key={row.TLemburID || id}
                                  className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}
                                >
                                  <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.TLemburID}</td>
                                  <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.NoSPL || "-"}</td>
                                  <td className="py-4 px-6">{row.NamaKaryawan || "-"}</td>
                                  <td className="py-4 px-6">{row.KeperluanLembur || "-"}</td>
                                  <td className="py-4 px-6 whitespace-nowrap text-xs">{row.TanggalMonitoring || "-"}</td>
                                  <td className="py-4 px-6 whitespace-nowrap text-xs font-semibold">
                                    {formatDurasiLembur(row.TanggalMulai, row.TanggalAkhir)}
                                  </td>
                                  <td className="py-4 px-6 whitespace-nowrap text-xs font-semibold">
                                    {row.FaktorLembur != null ? (
                                      <>{row.FaktorLembur} jam</>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td className="py-4 px-6">
                                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass(row.StatusKet)}`}>
                                      {row.StatusKet || "-"}
                                    </span>
                                    {Array.isArray(row.ApprovalList) && row.ApprovalList.length > 0 && (
                                      <div className="mt-2 space-y-0.5 text-xs text-gray-700">
                                        {row.ApprovalList.map((a, ai) => (
                                          <div key={ai} className="whitespace-nowrap">
                                            {a.Status} {a.Nama}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </td>
                                  <td className="py-4 px-6 whitespace-nowrap">
                                    <div className="flex gap-2">
                                      {isDraft && (
                                        <>
                                          <button
                                            onClick={() => doEdit(row)}
                                            className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-3 border border-gray-400 rounded shadow text-sm"
                                          >
                                            Edit
                                          </button>
                                          <button
                                            onClick={() => doSend(row)}
                                            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded shadow text-sm"
                                          >
                                            Kirim
                                          </button>
                                        </>
                                      )}
                                      {!isDraft && (
                                        <button
                                          onClick={() => doDetail(row)}
                                          className="bg-white hover:bg-blue-50 text-blue-600 font-semibold py-1 px-3 border border-blue-300 rounded shadow text-sm"
                                        >
                                          Detail
                                        </button>
                                      )}
                                      <button
                                        onClick={() => doDelete(row)}
                                        className="bg-white hover:bg-red-50 text-red-600 font-semibold py-1 px-3 border border-red-300 rounded shadow text-sm"
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* ── Info + Pagination ── */}
                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>
                        {filtered.length} data — periode{" "}
                        {new Date(Bulan).toLocaleDateString("id-ID", { month: "long", year: "numeric" })}
                      </span>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => setPageC((p) => Math.max(1, p - 1))}
                          disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Prev
                        </button>
                        <span>Page {safePage} / {totalPage}</span>
                        <button
                          onClick={() => setPageC((p) => Math.min(totalPage, p + 1))}
                          disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setTanggalMulai("");
            setTanggalAkhir("");
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            setJenisHariOverride("");
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  No SPL
                </label>
                <input
                  type="text"
                  disabled
                  value={
                    showModalEdit
                      ? currentData.NoSPL || ""
                      : "Otomatis (…/SPL/… di-generate saat simpan)"
                  }
                  className="appearance-none block w-full text-gray-500 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-gray-100 cursor-not-allowed"
                />
              </div>
              {/* <div className="w-full w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Lembur *
                </label>
                <input
                  value={values.JenisLembur}
                  onChange={changeHandler}
                  name="JenisLembur"
                  className={
                    (touched.JenisLembur || buttonTouched) && errors.JenisLembur
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.JenisLembur || buttonTouched) &&
                  errors.JenisLembur && (
                    <p className="text-red-500 text-xs italic">
                      {errors.JenisLembur}
                    </p>
                  )}
              </div> */}
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Keperluan Lembur *
                </label>
                <input
                  value={values.KeperluanLembur}
                  onChange={changeHandler}
                  name="KeperluanLembur"
                  className={
                    (touched.KeperluanLembur || buttonTouched) &&
                    errors.KeperluanLembur
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.KeperluanLembur || buttonTouched) &&
                  errors.KeperluanLembur && (
                    <p className="text-red-500 text-xs italic">
                      {errors.KeperluanLembur}
                    </p>
                  )}
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  {values["NamaFile"] && "Ganti "}
                  Data pendukung
                </label>
                <label
                  htmlFor={"NamaFile"}
                  className="block w-full border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                >
                  {values["NamaFile"] ? (
                    <span>
                      File Selected -{" "}
                      {values["NamaFile"].name
                        ? values["NamaFile"].name
                        : values["NamaFile"]}
                    </span>
                  ) : (
                    <span>Choose a file...</span>
                  )}
                </label>

                <input
                  type="file"
                  id={"NamaFile"}
                  key={"NamaFile"}
                  name={"NamaFile"}
                  style={{ visibility: "hidden" }}
                  className="block  border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  onChange={(e) => customHandler(e.target.files[0], "NamaFile")}
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Waktu Mulai *
                </label>
                <DatePicker
                  showTimeInput
                  dateFormat="MM/dd/yyyy HH:mm"
                  className={
                    !isValidTanggalMulai
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  selected={TanggalMulaiSelect}
                  onChange={(date) => {
                    setTanggalMulai(date.toLocaleString());
                    setTanggalMulaiSelect(date);
                    setTanggalAkhir("");
                    setTanggalAkhirSelect("");
                    setIsValidTanggalMulai(true);
                    setIsValidTanggalAkhir(false);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalMulai && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal mulai wajib diisi
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Waktu Akhir *
                </label>
                <DatePicker
                  showTimeInput
                  dateFormat="MM/dd/yyyy HH:mm"
                  className={
                    !isValidTanggalAkhir
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  disabled={TanggalMulai === ""}
                  minDate={new Date(TanggalMulai).setDate(
                    new Date(TanggalMulai).getDate()
                  )}
                  selected={TanggalAkhirSelect}
                  onChange={(date) => {
                    setTanggalAkhir(date.toLocaleString());
                    setTanggalAkhirSelect(date);
                    setIsValidTanggalAkhir(true);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalAkhir && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal akhir wajib diisi
                  </p>
                )}
              </div>
            </div>

            {/* ── Perhitungan Lembur (PP No. 35 Tahun 2021) ──────────────
                Preview transparan dari backend (sumber tunggal — angka yang
                sama persis akan tersimpan saat submit). */}
            {values.Nik && TanggalMulaiSelect && TanggalAkhirSelect && (
              <div className="w-full px-3 mb-6">
                <div className="border border-gray-200 rounded p-4 bg-gray-50">
                  <div className="text-xs font-bold uppercase text-gray-500 mb-3">
                    Perhitungan Lembur (PP No. 35 Tahun 2021)
                  </div>

                  {previewMutation.isLoading && (
                    <div className="text-sm text-gray-500">Menghitung…</div>
                  )}

                  {!previewMutation.isLoading && preview && (
                    <>
                      {preview.ErrorMessage ? (
                        <div className="text-sm text-red-600 font-medium">
                          {preview.ErrorMessage}
                        </div>
                      ) : (
                        <>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3 text-sm">
                            <div>
                              <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-1">
                                Jenis Hari
                              </label>
                              <select
                                value={jenisHariOverride}
                                onChange={(e) => setJenisHariOverride(e.target.value)}
                                className="block appearance-none w-full text-gray-700 border border-gray-300 rounded py-2 px-3 leading-tight outline-none bg-white text-sm"
                              >
                                {JENIS_HARI_OPTIONS.map((o) => (
                                  <option key={o.value} value={o.value}>
                                    {o.label}
                                  </option>
                                ))}
                              </select>
                              <div className="text-xs text-gray-400 mt-1">
                                Terdeteksi: <strong>{preview.JenisHariLabel}</strong> — {preview.JenisHariSumber}
                              </div>
                            </div>
                            <div>
                              <div className="text-xs font-bold uppercase text-gray-500 mb-1">
                                Pola Kerja
                              </div>
                              <div className="text-gray-800">{preview.PolaKerjaLabel}</div>
                              <div className="text-xs text-gray-400 mt-1">{preview.PolaKerjaSumber}</div>
                              {preview.HariKerjaTerpendek && (
                                <div className="text-xs text-orange-600 mt-1">
                                  Hari libur resmi jatuh pada hari kerja terpendek.
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominal Rupiah (upah bulanan/sejam/total) sengaja TIDAK
                              ditampilkan di halaman ini (permintaan user 2026-10-14) —
                              sama seperti modal detail: hanya jam & akumulasi durasi. */}
                          <div className="grid grid-cols-2 gap-3 mb-3 text-sm">
                            <div>
                              <div className="text-xs text-gray-500">Jam Lembur</div>
                              <div className="font-semibold">{preview.JamLembur} jam</div>
                            </div>
                            <div>
                              <div className="text-xs text-gray-500">Akumulasi Durasi</div>
                              <div className="font-semibold">{preview.FaktorLembur} jam</div>
                            </div>
                          </div>

                          {Array.isArray(preview.BreakdownLembur) && preview.BreakdownLembur.length > 0 && (
                            <div className="overflow-x-auto mb-3">
                              <table className="table-auto w-full text-xs text-left">
                                <thead className="text-gray-500 uppercase">
                                  <tr>
                                    <th className="py-1 pr-4">Jam ke-</th>
                                    <th className="py-1 pr-4">Faktor</th>
                                    <th className="py-1 pr-4">Durasi</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {preview.BreakdownLembur.map((b) => (
                                    <tr key={b.JamKe} className="border-t border-gray-200">
                                      <td className="py-1 pr-4">{b.JamKe}</td>
                                      <td className="py-1 pr-4">{b.Faktor}×</td>
                                      <td className="py-1 pr-4">{b.Durasi} jam</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}

                          <div className="flex justify-between items-center border-t border-gray-300 pt-2">
                            <span className="text-sm font-bold uppercase text-gray-600">Total Akumulasi Durasi</span>
                            <span className="text-lg font-bold text-green-700">{preview.FaktorLembur} jam</span>
                          </div>
                        </>
                      )}

                      {!preview.ErrorMessage && preview.Warning && (
                        <div className="mt-3 text-xs text-yellow-800 bg-yellow-100 border border-yellow-300 rounded px-3 py-2">
                          ⚠ {preview.Warning}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setTanggalMulai("");
              setTanggalMulaiSelect("");
              setTanggalAkhir("");
              setShowModalAdd(false);
              setShowModalEdit(false);
              setJenisHariOverride("");
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              (isValid || (showModalEdit && dateChanged && !isValid)) &&
              isValidTanggalMulai &&
              isValidTanggalAkhir
                ? "green"
                : "blueGray"
            }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              if (TanggalMulai === "") {
                setIsValidTanggalMulai(false);
              }
              if (TanggalAkhir === "") {
                setIsValidTanggalAkhir(false);
              }

              let tempIsValid = isValid;
              if (showModalEdit && dateChanged && !isValid) {
                tempIsValid = true;
              }
              if (tempIsValid && isValidTanggalMulai && isValidTanggalAkhir) {
                // Kirim jam dinding lokal perangkat (lihat toLocalTgl). Utamakan objek Date
                // dari DatePicker (…Select); fallback ke state bila perlu.
                const toISO = (sel, fallback) =>
                  toLocalTgl(sel instanceof Date ? sel : parseLemburTgl(fallback));
                const tanggal = {
                  TanggalMulai: toISO(TanggalMulaiSelect, TanggalMulai),
                  TanggalAkhir: toISO(TanggalAkhirSelect, TanggalAkhir),
                  TLemburID: currentData.TLemburID,
                  // Kalkulasi upah lembur (PP 35/2021) dihitung ULANG & disimpan oleh
                  // backend saat submit — nilai yang sama dgn kartu "Perhitungan Lembur"
                  // di atas. Override jenis hari (bila dipilih manual) ikut dikirim.
                  JenisHariOverride: jenisHariOverride,
                };

                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  createNotification("Berhasil mengubah data", "success");
                  if (values["NamaFile"]) {
                    try {
                      const { v4: uuidv4 } = require("uuid");

                      const uuid = uuidv4();
                      let formData = new FormData();
                      const nama =
                        uuid +
                        "-" +
                        values["NamaFile"].name.replaceAll(" ", "_");
                      formData.append("file", values["NamaFile"], nama);
                      mutationFile.mutate(formData);
                      values["NamaFile"] = nama;
                    } catch (error) {
                      console.log(error);
                    }
                  }

                  dispatch(
                    updateLemburTransaksi(Object.assign(values, tanggal))
                  );
                } else {
                  // createNotification("Berhasil mengubah data", "success");
                  if (values["NamaFile"]) {
                    try {
                      const { v4: uuidv4 } = require("uuid");

                      const uuid = uuidv4();
                      let formData = new FormData();
                      const nama =
                        uuid +
                        "-" +
                        values["NamaFile"].name.replaceAll(" ", "_");
                      formData.append("file", values["NamaFile"], nama);
                      mutationFile.mutate(formData);
                      values["NamaFile"] = nama;
                    } catch (error) {
                      console.log(error);
                    }
                  }
                  // dispatch(
                  //   insertLemburTransaksi(Object.assign(values, tanggal))
                  // );
                  mutationInput.mutate(Object.assign(values, tanggal), {
                    onSuccess: async (data, context) => {
                      toast.success(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      setShowModalAdd(false);
                      setShowModalEdit(false);
                      mutation.mutate({
                        start: start,
                        count: count,
                        search: search,
                      });
                    },
                    onError: async (data, context) => {
                      toast.error(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                    },
                  });
                }
              }
            }}
            ripple={
              isValid && isValidTanggalMulai && isValidTanggalAkhir
                ? "light"
                : ""
            }
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal Detail: status approval + alasan tolak/terima per approver ── */}
      <Modal
        size="regular"
        active={showModalDetail}
        toggler={() => setShowModalDetail(true)}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalDetail(false);
            setDetailID("");
          }}
        >
          Detail Approval Lembur
        </ModalHeader>
        <ModalBody>
          {lembur.SpecLemburData &&
          lembur.SpecLemburData.TLemburID === detailID ? (
            <div className="w-full">
              {/* Info ringkas pengajuan */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">
                    Nama Karyawan
                  </div>
                  <div className="text-gray-800">
                    {detailRow.NamaKaryawan || "-"}
                  </div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">
                    No SPL
                  </div>
                  <div className="text-gray-800 font-mono text-sm">
                    {detailRow.NoSPL || "-"}
                  </div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">
                    Keperluan Lembur
                  </div>
                  <div className="text-gray-800">
                    {detailRow.KeperluanLembur || "-"}
                  </div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">
                    Status
                  </div>
                  <div className="text-gray-800">
                    {detailRow.StatusKet || "-"}
                  </div>
                </div>
              </div>

              {/* ── Perhitungan Lembur (PP No. 35 Tahun 2021) ── */}
              <div className="border-t pt-3 mb-3">
                <div className="font-semibold text-gray-700 mb-2">Perhitungan Lembur</div>
                {lembur.SpecLemburData.TotalUpahLembur != null ? (
                  <>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3 text-sm">
                      <div>
                        <div className="text-xs text-gray-500">Jenis Hari</div>
                        <div className="font-semibold">{lembur.SpecLemburData.JenisHariLabel}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500">Pola Kerja</div>
                        <div className="font-semibold">{lembur.SpecLemburData.PolaKerjaLabel}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500">Jam Lembur</div>
                        <div className="font-semibold">{lembur.SpecLemburData.JamLembur} jam</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500">Akumulasi Durasi</div>
                        <div className="font-semibold">{lembur.SpecLemburData.FaktorLembur} jam</div>
                      </div>
                    </div>
                    {Array.isArray(lembur.SpecLemburData.BreakdownLembur) &&
                      lembur.SpecLemburData.BreakdownLembur.length > 0 && (
                        <div className="overflow-x-auto mb-2">
                          <table className="table-auto w-full text-xs text-left">
                            <thead className="text-gray-500 uppercase">
                              <tr>
                                <th className="py-1 pr-4">Jam ke-</th>
                                <th className="py-1 pr-4">Faktor</th>
                                <th className="py-1 pr-4">Durasi</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lembur.SpecLemburData.BreakdownLembur.map((b) => (
                                <tr key={b.JamKe} className="border-t border-gray-200">
                                  <td className="py-1 pr-4">{b.JamKe}</td>
                                  <td className="py-1 pr-4">{b.Faktor}×</td>
                                  <td className="py-1 pr-4">{b.Durasi} jam</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    <div className="flex justify-between items-center border-t border-gray-300 pt-2">
                      <span className="text-sm font-bold uppercase text-gray-600">Total Akumulasi Durasi</span>
                      <span className="text-lg font-bold text-green-700">
                        {lembur.SpecLemburData.FaktorLembur} jam
                      </span>
                    </div>
                    {lembur.SpecLemburData.WarningLembur && (
                      <div className="mt-2 text-xs text-yellow-800 bg-yellow-100 border border-yellow-300 rounded px-3 py-2">
                        ⚠ {lembur.SpecLemburData.WarningLembur}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-gray-400 text-sm">
                    {lembur.SpecLemburData.WarningLembur || "Kalkulasi belum tersedia untuk dokumen ini."}
                  </div>
                )}
              </div>

              <div className="border-t pt-3 mb-2 font-semibold text-gray-700">
                Riwayat Approval
              </div>
              {Array.isArray(lembur.SpecLemburData.Approval) &&
              lembur.SpecLemburData.Approval.length > 0 ? (
                <div className="space-y-2">
                  {lembur.SpecLemburData.Approval.map((a, ai) => {
                    const badge =
                      a.Approve === "Ditolak"
                        ? "bg-red-100 text-red-800"
                        : a.Approve === "Sudah diApprove"
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-600";
                    return (
                      <div
                        key={ai}
                        className="border rounded px-4 py-3 flex flex-col gap-1"
                      >
                        <div className="flex items-center justify-between gap-2">
                          <span className="font-medium text-gray-800">
                            {a.NamaBagian} — {a.NamaJabatan}
                          </span>
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${badge}`}
                          >
                            {a.Approve}
                          </span>
                        </div>
                        {a.Approve !== "Belum diApprove" && a.TanggalApproved && (
                          <div className="text-xs text-gray-600">
                            {a.Approve === "Ditolak"
                              ? "Alasan penolakan: "
                              : "Catatan: "}
                            {a.TanggalApproved}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-gray-400 text-sm py-2">
                  Belum ada data approval.
                </div>
              )}
            </div>
          ) : (
            <div className="flex justify-center py-8">
              <Loading />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="blueGray"
            buttonType="link"
            onClick={() => {
              setShowModalDetail(false);
              setDetailID("");
            }}
            ripple="dark"
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LemburPage;
